import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ViewPayslipPage from "./Pages/Payslip/ViewPayslipPage";
import "./scss/index.scss";
import "react-tooltip/dist/react-tooltip.css";
import "react-loading-skeleton/dist/skeleton.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store";
import AuthRoutes from "./ProtectedRoutes/AuthRoutes";
import ManagerRoutes from "./ProtectedRoutes/ManagerRoutes";
import RootLayout from "./layouts/RootLayout/RootLayout";
import { useTranslation } from "react-i18next";
import Home from "./components/Home";
import Login from "./Pages/Auth/Login";
import Register from "./Pages/Auth/Register";
import AccountsMain from "./Pages/Accounts/AccountsMain";
import CreateAccountPage from "./Pages/Accounts/CreateAccountPage";
import ViewAccountPage from "./Pages/Accounts/ViewAccountPage";
import InvoicesMain from "./Pages/Invoice/InvoicesMain";
import ReceivePaymentInvoicePage from "./Pages/Invoice/ReceivePaymentInvoicePage";
import CompanyInvoicesMain from "./Pages/CompanyInvoice/CompanyInvoicesMain";
import RecievePaymentCompanyInvoicePage from "./Pages/CompanyInvoice/RecievePaymentCompanyInvoicePage";
import TransactionsMain from "./Pages/Transactions/TransactionsMain";
import CustomerMain from "./Pages/Customer/CustomerMain";
import CreateCustomerpage from "./Pages/Customer/CreateCustomerpage";
import UsersMain from "./Pages/User/UsersMain";
import ReportMain from "./Pages/Report/ReportMain";
import ShowInvoice from "./Pages/Invoice/ShowInvoice";
import MainBusiness from "../src/business/MainBusiness";
import BusinessPage from "./business/Businesspage";
import ShowCompanyInvoice from "./Pages/CompanyInvoice/ShowCompanyInvoice";
import PayslipMain from "./Pages/Payslip/PayslipMain";
import PayrollMain from "./Pages/Payroll/PayrollMain";
import CreateAttendancepage from "./Pages/Attendance/CreateAttendencepage";
import ViewAttendancePage from "./Pages/Attendance/ViewAttendancePage";
import CreateLeavepage from "./Pages/Leave/CreateLeavepage";
import ViewLeavePage from "./Pages/Leave/ViewLeavePage";
import CreateDeductionpage from "./Pages/Deduction/CreateDeductionpage";
import ViewDeductionPage from "./Pages/Deduction/ViewDeductionPage";
import CreateAllowancepage from "./Pages/Allowance/CreateAllowancepage";
import ViewAllowancePage from "./Pages/Allowance/ViewAllowancePage";
import CreatePayrun from "./Pages/Payrun/Payrunpage";
import ViewPayrunPage from "./Pages/Payrun/ViewPayrunPage";
import CraetePayroll from "./Pages/Payrun/Payrollpage";
import VendorMain from "./Pages/Vendor/VendorMain";
import ViewVendorPage from "./Pages/Vendor/ViewVendorPage";
import CreateVendorpage from "./Pages/Vendor/CreateVendorpage";
import PurchasedEntryMain from "./Pages/PurchasedEntry/PurchasedEntryMain";
import CreateInvoicePage from "./Pages/Invoice/CreateInvoicePage";
import CreateCompanyInvoicePage from "./Pages/CompanyInvoice/CreateCompanyInvoicePage";
import CreateEmployeePage from "./Pages/Employee/CreateEmployeePage";
import ViewEmployeePage from "./Pages/Employee/ViewEmployeePage";
import BranchMain from "./Pages/Branch/BranchMain";
import CreateBranchPage from "./Pages/Branch/CreateBranchPage";
import CostCenterMain from "./Pages/CostCenter/CostCenterMain";
import CreateCostCenterPage from "./Pages/CostCenter/CreateCostCenterPage";
import CreateTransactionPage from "./Pages/Transactions/CreateTransactionPage";
import CreatePurchasedEntryPage from "./Pages/PurchasedEntry/CreatePurchasedEntryPage";
import EditPurchasedEntryPage from "./Pages/PurchasedEntry/EditPurchasedEntryPage";
import ViewPurchasedEntryPage from "./Pages/PurchasedEntry/ViewPurchasedEntryPage";
import ReceivePaymentPage from "./Pages/PurchasedEntry/ReceivePaymentPage";
import CreditTable from "./CreditInvoice/CreditTable";
import CreditCompanyInvoice from "./CreditInvoice/CrdeitCompanyTable";
import ReceiveCompanyPaymentPage from "./CreditInvoice/ReceiveCompanyPaymentPage";
import RecieveSalePaymentPage from "./CreditInvoice/RecieveSalePaymentPage";
import PaymentVoucher from "./Pages/Voucher/PaymentVoucher";
import ViewPaymentVoucherPage from "./Pages/Voucher/ViewPaymentVoucherPage";
import ReceiptVoucher from "./Pages/Voucher/ReceiptVoucher";
import ViewReceiptVoucherPage from "./Pages/Voucher/ViewReceiptVoucherPage";
import CreatePaymentVoucher from "./Pages/Voucher/CreatePaymentVoucher";
import CreateReceiptVoucher from "./Pages/Voucher/CreateReceiptVoucher";
import ExcelTransactionPage from "./Pages/Transactions/ExcelTransactionPage";
import CreateJournalEntries from "./Pages/Transactions/CreateJournalEntries";
import ViewTransactionPage from "./Pages/Transactions/ViewTransactionPage";
import JournalAuditLogsPage from "./Pages/Transactions/JournalAuditLogsPage";
import JournalLedgerMain from "./Pages/JournalLedger/JournalLedgerMain";
import Settings from "./Pages/settings/Settings";
import CreateSettings from "./Pages/settings/CreateSettings";
import ThirdParty from "./thirdParty/ThirdParty";
import ShowThirdPartyInvoice from "./thirdParty/ShowThirdPartyInvoice";
import ThirdPartyRoutes from "./ProtectedRoutes/ThirdPartyRoutes";
import P2PInsuranceInvoice from "./thirdParty/P2PInsuranceInvoice";
import InvoiceDetails from "./thirdParty/InvoiceDetails";
import InsuranceClaimInvoice from "./Pages/insuranceClaimInvoice/InsuranceClaimInvoice";
import CreateInsuranceInvoicePage from "./Pages/insuranceClaimInvoice/CreateInsuranceInvoicePage";
import TPA from "./Pages/Tpa/TPA";
import Tpapage from "./Pages/Tpa/Tpapage";
import NewSettings from "./components/settings/NewSettings";
import NewCreateSeetingDialog from "./components/settings/NewCreateSeetingDialog";
import CreateGLPostSetting from "./components/settings/CreateGLPostSetting";
import CreditClaimInvoice from "./Pages/insuranceClaimInvoice/CreditClaimInvoice";
import ThirdPartyRevokeInvoice from "./thirdParty/ThirdPartyRevokeInvoice";
import HisInvoices from "./Pages/hisInvoices/HisInvoices";
import HisCompanyInvoice from "./Pages/hisInvoices/HisCompanyInvoice";
import HisCreditNotes from "./Pages/hisInvoices/HisCreditNotes";
import HisCreditCompanyNotes from "./Pages/hisInvoices/HisCreditCompanyNotes";
import DepositInvoice from "./Pages/hisInvoices/DepositInvoice";
import PaymentMethodsMain from "./Pages/PaymentMethods/PaymentMethodsMain";
import PaymentMethodsPage from "./Pages/PaymentMethods/PaymentMethodsPage";
import PayerSettingsPage from "./Pages/settings/PayerSettingsPage";
import PaymentSettingsPage from "./Pages/settings/PaymentSettingsPage";
import EntryDetailsPage from "./Pages/Ledger/EntryDetailsPage";
import EnteryDetailPage from "./Pages/AccountStatement/EnteryDetailPage";
import IncomeDetailPage from "./Pages/Income/IncomeDetailPage";
import DailyInvoiceReport from "./Pages/hisInvoices/DailyInvoiceReport";
import OpeningBalances from "./Pages/OpeningBalances/OpeningBalances";
import ERPPurchasingDashboard from "./Pages/SupplyChainERP/ERPPurchasingDashboard";
import ERPSuppliersMain from "./Pages/SupplyChainERP/ERPSuppliersMain";
import ERPItemsMain from "./Pages/SupplyChainERP/ERPItemsMain";
import CreateERPItemPage from "./Pages/SupplyChainERP/CreateERPItemPage";
import ERPPurchaseInvoicesMain from "./Pages/SupplyChainERP/ERPPurchaseInvoicesMain";
import CreateERPPurchaseInvoicePage from "./Pages/SupplyChainERP/CreateERPPurchaseInvoicePage";
import ERPSaleInvoicesMain from "./Pages/SupplyChainERP/ERPSaleInvoicesMain";
import CreateERPSaleInvoicePage from "./Pages/SupplyChainERP/CreateERPSaleInvoicePage";
import ERPSaleInvoiceDetailPage from "./Pages/SupplyChainERP/ERPSaleInvoiceDetailPage";
import ERPPurchasingStats from "./Pages/SupplyChainERP/ERPPurchasingStats";


function App() {
  const { i18n } = useTranslation();

  // Set the direction based on the language
  useEffect(() => {
    const direction = i18n.language === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", direction);
    document.body.setAttribute("dir", direction);
  }, [i18n.language]);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Routes>
            <Route element={<AuthRoutes />}>
              <Route path="/login" exact element={<Login />} />
              <Route path="/register" exact element={<Register />} />
            </Route>

            <Route
              path="/manager"
              element={
                <RootLayout>
                  <ManagerRoutes />
                </RootLayout>
              }
            >
              <Route path="his-cash-invoices" exact element={<HisInvoices />} />
              <Route
                path="his-company-invoices"
                exact
                element={<HisCompanyInvoice />}
              />
              <Route
                path="his-credit-notes"
                exact
                element={<HisCreditNotes />}
              />
              <Route
                path="his-credit-company-notes"
                exact
                element={<HisCreditCompanyNotes />}
              />
              <Route
                path="his-deposit-invoices"
                exact
                element={<DepositInvoice />}
              />
              <Route
                path="payment/methods"
                exact
                element={<PaymentMethodsMain />}
              />
              <Route
                path="payment/methods/create"
                exact
                element={<PaymentMethodsPage />}
              />
              <Route path="dashboard" exact element={<Home />} />
              <Route path="tpa" exact element={<TPA />} />
              <Route path="tpa/create" exact element={<Tpapage />} />
              <Route path="settings" exact element={<NewSettings />} />
              <Route
                path="settings/create"
                exact
                element={<NewCreateSeetingDialog />}
              />
              <Route
                path="settings/gl/create"
                exact
                element={<CreateGLPostSetting />}
              />
              <Route
                path="settings/payer/create"
                exact
                element={<PayerSettingsPage />}
              />
              <Route
                path="settings/payment/create"
                exact
                element={<PaymentSettingsPage />}
              />
              <Route path="user" exact element={<UsersMain />} />
              <Route path="accounts" exact element={<AccountsMain />} />
              <Route
                path="accounts/create"
                exact
                element={<CreateAccountPage />}
              />
              <Route path="accounts/view" exact element={<ViewAccountPage />} />
              <Route path="transactions" exact element={<TransactionsMain />} />
              <Route
                path="transactions/create"
                exact
                element={<CreateJournalEntries />}
              />
              <Route
                path="transactions/view"
                exact
                element={<ViewTransactionPage />}
              />
              <Route
                path="transactions/audit/:journalEntryNumber"
                exact
                element={<JournalAuditLogsPage />}
              />
              <Route
                path="journal-ledger"
                exact
                element={<JournalLedgerMain />}
              />
              {/* <Route
                path="transactions/create"
                exact
                element={<CreateTransactionPage />}
              /> */}
              <Route
                path="opening-balances"
                exact
                element={<OpeningBalances />}
              />
              <Route
                path="transactions/edit"
                exact
                element={<CreateTransactionPage />}
              />
              <Route path="invoices" exact element={<InvoicesMain />} />
              <Route
                path="invoices/create"
                exact
                element={<CreateInvoicePage />}
              />
              <Route
                path="invoices/payment"
                exact
                element={<ReceivePaymentInvoicePage />}
              />
              <Route path="customers" exact element={<CustomerMain />} />
              <Route
                path="customers/create"
                exact
                element={<CreateCustomerpage />}
              />
              {/* <Route path="payslip" exact element={<PayslipMain />} /> */}
              <Route
                path="insuranceInvoice"
                exact
                element={<CompanyInvoicesMain />}
              />
              <Route
                path="insuranceInvoice/payment"
                exact
                element={<RecievePaymentCompanyInvoicePage />}
              />
              <Route
                path="insurance-claim-invoice"
                exact
                element={<InsuranceClaimInvoice />}
              />

              <Route
                path="credit-claim-invoice"
                exact
                element={<CreditClaimInvoice />}
              />
              <Route
                path="create-insurance-claim-invoice"
                exact
                element={<CreateInsuranceInvoicePage />}
              />
              <Route
                path="p2p-insurance-invoice"
                exact
                element={<P2PInsuranceInvoice />}
              />
              <Route
                path="creditInvoiceTable"
                exact
                element={<CreditTable />}
              />
              <Route
                path="creditCompanyInvoiceTable"
                exact
                element={<CreditCompanyInvoice />}
              />
              <Route
                path="credit/company-payment"
                exact
                element={<ReceiveCompanyPaymentPage />}
              />
              <Route
                path="credit/sale-payment"
                exact
                element={<RecieveSalePaymentPage />}
              />
              <Route
                path="insuranceInvoice/create"
                exact
                element={<CreateCompanyInvoicePage />}
              />
              <Route path="items" exact element={<ERPItemsMain />} />
              <Route
                path="items/create"
                exact
                element={<CreateERPItemPage />}
              />
              <Route
                path="items/edit/:id"
                exact
                element={<CreateERPItemPage />}
              />
              <Route path="report" exact element={<ReportMain />} />
              <Route path="show-invoice" exact element={<ShowInvoice />} />
              <Route
                path="show-company-invoice"
                exact
                element={<ShowCompanyInvoice />}
              />
              <Route path="business" exact element={<MainBusiness />} />
              <Route path="business/create" exact element={<BusinessPage />} />
              <Route path="branch" exact element={<BranchMain />} />
              <Route
                path="branch/create"
                exact
                element={<CreateBranchPage />}
              />
              <Route path="costCenter" exact element={<CostCenterMain />} />
              <Route
                path="costCenter/create"
                exact
                element={<CreateCostCenterPage />}
              />
              <Route path="report" exact element={<ReportMain />} />
              <Route
                path="report/ledger-entries/:journalNumber"
                exact
                element={<EntryDetailsPage />}
              />
              <Route
                path="report/account-statement-entries/:journalNumber"
                exact
                element={<EnteryDetailPage />}
              />
              <Route
                path="report/income-details"
                exact
                element={<IncomeDetailPage />}
              />
              {/* <Route path="employees" exact element={<EmployeeMain />} />
              <Route path="leave" exact element={<LeaveMain />} />
              <Route path="attendance" exact element={<AttendanceMain />} />
              <Route path="deduction" exact element={<DeductionMain />} />
              <Route path="allowance" exact element={<AllowanceMain />} /> */}
              <Route path="payroll" exact element={<PayrollMain />} />
              <Route
                path="attendance/create"
                exact
                element={<CreateAttendancepage />}
              />
              <Route
                path="attendance/view"
                exact
                element={<ViewAttendancePage />}
              />
              <Route path="leave/create" exact element={<CreateLeavepage />} />
              <Route path="leave/view" exact element={<ViewLeavePage />} />
              <Route
                path="deduction/create"
                exact
                element={<CreateDeductionpage />}
              />
              <Route
                path="deduction/view"
                exact
                element={<ViewDeductionPage />}
              />
              <Route
                path="allowance/create"
                exact
                element={<CreateAllowancepage />}
              />
              <Route
                path="allowance/view"
                exact
                element={<ViewAllowancePage />}
              />
              <Route path="payrun/create" exact element={<CreatePayrun />} />
              <Route path="payrun/view" exact element={<ViewPayrunPage />} />
              <Route path="payslip/view" exact element={<ViewPayslipPage />} />
              <Route path="payrolls/create" exact element={<CraetePayroll />} />
              <Route
                path="payroll/create"
                exact
                element={<CreateEmployeePage />}
              />
              <Route path="payroll/view" exact element={<ViewEmployeePage />} />

              <Route path="vendor" exact element={<VendorMain />} />
              <Route
                path="vendor/create"
                exact
                element={<CreateVendorpage />}
              />
              <Route path="vendor/view" exact element={<ViewVendorPage />} />
              <Route
                path="purchased_entry"
                exact
                element={<PurchasedEntryMain />}
              />
              <Route
                path="purchased_entry/create"
                exact
                element={<CreatePurchasedEntryPage />}
              />
              <Route
                path="purchased_entry/edit"
                exact
                element={<EditPurchasedEntryPage />}
              />
              <Route
                path="purchased_entry/view"
                exact
                element={<ViewPurchasedEntryPage />}
              />
              <Route
                path="purchased_entry/receive-payment"
                exact
                element={<ReceivePaymentPage />}
              />
              <Route
                path="receipt/voucher"
                exact
                element={<ReceiptVoucher />}
              />
              <Route
                path="create/payment/voucher"
                exact
                element={<CreatePaymentVoucher />}
              />
              <Route
                path="create/receipt/voucher"
                exact
                element={<CreateReceiptVoucher />}
              />
              <Route
                path="payment/voucher"
                exact
                element={<PaymentVoucher />}
              />
              <Route
                path="payment/voucher/view"
                exact
                element={<ViewPaymentVoucherPage />}
              />
              <Route
                path="receipt/voucher/view"
                exact
                element={<ViewReceiptVoucherPage />}
              />
              <Route
                path="his-daily-invoice-report"
                exact
                element={<DailyInvoiceReport />}
              />
              <Route path="erp/dashboard" exact element={<ERPPurchasingDashboard />} />
              <Route path="erp/purchasing-stats" exact element={<ERPPurchasingStats />} />
              <Route path="erp/suppliers" exact element={<ERPSuppliersMain />} />
              <Route path="erp/items" exact element={<ERPItemsMain />} />
              <Route path="erp/items/create" exact element={<CreateERPItemPage />} />
              <Route path="erp/items/edit/:id" exact element={<CreateERPItemPage />} />
<Route path="erp/purchase-invoices" exact element={<ERPPurchaseInvoicesMain />} />
              <Route path="erp/purchase-invoices/create" exact element={<CreateERPPurchaseInvoicePage />} />
              <Route path="erp/purchase-invoices/edit/:id" exact element={<CreateERPPurchaseInvoicePage />} />
              <Route path="erp/sale-invoices" exact element={<ERPSaleInvoicesMain />} />
              <Route path="erp/sale-invoices/create" exact element={<CreateERPSaleInvoicePage />} />
              <Route path="erp/sale-invoices/edit/:id" exact element={<CreateERPSaleInvoicePage />} />
              <Route path="erp/sale-invoices/:id" exact element={<ERPSaleInvoiceDetailPage />} />
            </Route>




            <Route
              path="/zatca"
              element={
                <RootLayout>
                  <ThirdPartyRoutes />
                </RootLayout>
              }
            >
              <Route path="thirdparty" exact element={<ThirdParty />} />
              <Route
                path="thirdparty/invoice-details/:clientOrderID"
                exact
                element={<ShowThirdPartyInvoice />}
              />

              <Route
                path="thirdparty/invoice-details-revoke/:clientOrderID"
                exact
                element={<ThirdPartyRevokeInvoice />}
              />
              <Route
                path="thirdparty/p2p-insurance-invoice"
                exact
                element={<P2PInsuranceInvoice />}
              />
              <Route
                path="thirdparty/simple-invoice-details/:id"
                exact
                element={<InvoiceDetails />}
              />
              <Route
                path="thirdparty/insurance-claim-invoice"
                exact
                element={<InsuranceClaimInvoice />}
              />
              <Route
                path="thirdparty/create-insurance-claim-invoice"
                exact
                element={<CreateInsuranceInvoicePage />}
              />
            </Route>

            <Route path="/" element={<Navigate to="/login" />} />
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
